<template>
  <div class="vcl-auth-proxy"></div>
</template>
<script>

export default {
  name: 'VpAuthProxy',
  inject: ['$busy', '$auth'],
  emits: ['auth'],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$busy.on(true);
      const { logon, dataStore } = this.$deps;
      const { uid, token = null, houseId = null, totp = false } = this.$route.query;

      if (uid && token && houseId) {
        dataStore.set('houseId', houseId);
        if (totp) {
          this.$busy.on(false);
          return this.$router.push({ path: 'totp', query: { uid, token } });
        }

        return logon.login({ uid, token })
          .then((data) => {
            const { loggedIn } = data;

            if (!loggedIn) {
              this.$auth.set(false);
              return this.$router.push({ path: '/logon/error', query: {} });
            }

            this.$auth.set(true);
            return this.$router.push({ path: '/', query: {} });
          })
          .finally(() => {
            this.$busy.on(false);
          });
      }

      this.$busy.on(false);
      return this.$router.push({ path: '/logon', query: {} });
    }
  }
};
</script>
